import { useState } from 'react';
import { BatchHistoryTable } from '../components/BatchHistoryTable';
import { HistoricalTable } from '../components/HistoricalTable';

type HistoryTab = 'scan' | 'batch';

/**
 * Interior history page — tabbed scan/batch views. 1:1 functional
 * clone of the lightning history page (filters, columns, buttons,
 * pagination, export) — the only deltas are the data source (interior
 * sub-app) and the cost helper (FAL `direct_cost` only, no pricing
 * fallback).
 */
export function InteriorHistoryPage() {
  const [activeTab, setActiveTab] = useState<HistoryTab>('scan');

  return (
    <div className="space-y-6">
      <div className="flex border-b border-surface-200">
        <button
          onClick={() => setActiveTab('scan')}
          className={`px-4 py-2.5 text-sm font-medium transition-colors relative ${
            activeTab === 'scan'
              ? 'text-primary-700'
              : 'text-surface-500 hover:text-surface-700'
          }`}
        >
          <div className="flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Scan History
          </div>
          {activeTab === 'scan' && (
            <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-600 rounded-t" />
          )}
        </button>
        <button
          onClick={() => setActiveTab('batch')}
          className={`px-4 py-2.5 text-sm font-medium transition-colors relative ${
            activeTab === 'batch'
              ? 'text-primary-700'
              : 'text-surface-500 hover:text-surface-700'
          }`}
        >
          <div className="flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
            Batch History
          </div>
          {activeTab === 'batch' && (
            <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-600 rounded-t" />
          )}
        </button>
      </div>

      {activeTab === 'scan' ? <HistoricalTable /> : <BatchHistoryTable />}
    </div>
  );
}
